import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  TimePicker,
  Space,
  message,
} from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { postRequest } from "../../utils/APICall";
import { SelectEmployee } from "../SelectInput";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import * as Yup from "yup";
const { confirm } = Modal;
const { TextArea } = Input;

const TaskModal = ({
  isModalOpen,
  handleOk,
  handleCancel,
  selectedTask,
  setProjects,
  projects,
  setTableReFetchData,
}) => {
  const [form] = Form.useForm();
  const [employeeId, setEmployeeId] = useState(null);
  const [loading, setLoading] = useState(false);
  // const { users } = useSelector((state) => state.user || {});
  const { allEmployee } = useSelector((state) => state.employees);
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee);
  const [assignTime, setAssignTime] = useState(null);
  const [deadLineTime, setDeadLineTime] = useState(null);
  const [assignTypeId, setAssignTypeId] = useState(1);
  const [completeTime, setCompleteTime] = useState(null);

  useEffect(() => {
    if (selectedTask) {
      // console.log("selectedTask >>>>>>>>>>", selectedTask?.STATUS, typeof selectedTask?.STATUS);
      const assignStaffValue = selectedTask?.TEAM_MEMBERS
        ? selectedTask?.TEAM_MEMBERS.split("|").map((id) => Number(id)) // team -> array
        : selectedTask?.ASSIGNTO
          ? [Number(selectedTask?.ASSIGNTO)] // individual -> single value in array
          : [];
      if (selectedTask?.COMPLETEDATE) {
        setCompleteTime(dayjs(selectedTask.COMPLETEDATE).format("HH:mm:ss"));
      }

      form.setFieldsValue({
        taskSubject: selectedTask?.CLIENTTITLE || "",
        project: selectedTask?.PROJECTID
          ? Number(selectedTask?.PROJECTID)
          : undefined,
        complainDate: selectedTask?.COMPLAINDATE
          ? dayjs(selectedTask?.COMPLAINDATE)
          : null,
        complainsource: selectedTask?.COMPLAINBY || "",
        assignBy: selectedTask?.CREATEBY || "",
        status:
          selectedTask?.STATUS_ID !== undefined ? Number(selectedTask?.STATUS_ID) : 0,
        assignType: selectedTask?.TEAM_MEMBERS ? 2 : 1,
        assignStaff: assignStaffValue,
        assigndate: selectedTask?.ASSIGNDATE
          ? dayjs(selectedTask?.ASSIGNDATE)
          : null,
        assignTime: selectedTask?.ASSIGNDATE
          ? dayjs(selectedTask?.ASSIGNDATE)
          : null,
        deadline: selectedTask?.DUE_DATE ? dayjs(selectedTask?.DUE_DATE) : null,
        deadlineTime: selectedTask?.DUE_DATE
          ? dayjs(selectedTask?.DUE_DATE)
          : null,

        feature: selectedTask?.WORK_TYPE || "",
        priority: selectedTask?.PRIORITY_ID
          ? Number(selectedTask?.PRIORITY_ID)
          : null,
        approvedBy: selectedTask?.APPROVEBY || "",
        approvedDate: selectedTask?.APPROVEDATE
          ? dayjs(selectedTask?.APPROVEDATE)
          : null,

        completeDate: selectedTask?.COMPLETEDATE
          ? dayjs(selectedTask?.COMPLETEDATE)
          : null,
        completeTime: selectedTask?.COMPLETEDATE
          ? dayjs(selectedTask?.COMPLETEDATE)
          : null,

        description: selectedTask?.DESCRIPTION || "",
        review: selectedTask?.REMARKS || "",
      });

      if (selectedTask?.ASSIGNDATE) {
        setAssignTime(dayjs(selectedTask.ASSIGNDATE).format("HH:mm:ss"));
      } // aj ka kam
      if (selectedTask?.DUEDATE) {
        setDeadLineTime(dayjs(selectedTask.DUEDATE).format("HH:mm:ss"));
      } // aj ka kam

      // keep state in sync with form
      setEmployeeId(assignStaffValue);
      setAssignTypeId(selectedTask?.TEAM_MEMBERS ? 2 : 1);
    }
  }, [selectedTask, form]);

  const onFinish = async (values) => {
    // Format all dates as DD-MM-YYYY

    setTableReFetchData((prev) => (prev == 0 ? prev + 1 : prev - 1));

    const formattedDeadline = values.deadline
      ? dayjs(values.deadline).format("DD-MMMM-YYYY") +
      ` ${deadLineTime || "00:00:00"}`
      : null;

    // console.log(assignTime, "assignTime in onfinish <<<<<<<<<");

    const formattedAssignDate = values.assigndate
      ? dayjs(values.assigndate).format("DD-MMMM-YYYY") +
      ` ${assignTime || "00:00:00"}`
      : null;

    const formattedComplainDate = values.complainDate
      ? dayjs(values.complainDate).format("DD-MMMM-YYYY")
      : null;

    const formattedCreateDate = dayjs().format("DD-MMMM-YYYY");
    const formattedLastUpdate = dayjs().format("DD-MMMM-YYYY HH:mm:ss");

    const formattedCompleteDate = values.completeDate
      ? dayjs(values.completeDate).format("DD-MMMM-YYYY") +
      ` ${completeTime || "00:00:00"}`
      : null;
    // console.log(values , "values //////////////");
    const payload = {
      taskId: selectedTask?.ID || null,
      projectId: values.project,
      subject: values.taskSubject,
      description: values.description ? values.description : "",
      complainBy: values.complainsource,
      complainDate: formattedComplainDate,
      workType: values.feature,
      createBy: values.assignBy,
      createDate: formattedCreateDate,
      assignType: assignTypeId,
      assignTo: assignTypeId === 1 ? values.assignStaff : null,
      teamMember: assignTypeId === 2 ? values.assignStaff.join("|") : null,
      assignDate: formattedAssignDate,
      priority: values.priority,
      taskStatus: values.status,
      dueDate: formattedDeadline,
      approveBy: values.approvedBy || null,
      approveDate: values.approvedDate
        ? dayjs(values.approvedDate).format("DD-MMM-YYYY")
        : null,
      completeDate: formattedCompleteDate,

      review: values.review || null,
      lastUpdate: formattedLastUpdate, // Use consistent format for lastUpdate
      // lastUpdateby: assignTypeId === 1 ? values.assignStaff : values.assignStaff.join("|"),
    };
    console.log(payload , "payload <<<<<<<<<<<");
    try {
      setLoading(true);
      const response = await postRequest("addTask", payload);
      // console.log("response" , response);

      if (response.success) {
        message.success(
          selectedTask
            ? "Task updated successfully!"
            : "Task added successfully!"
        );

        setTableReFetchData((prev) => (prev == 0 ? prev + 1 : prev - 1));

        form.resetFields();
       
      } else {
        console.error("Task creation failed:", response.error || response);
        message.error(response.error);
      }
    }
     catch (err) {
      console.error("Unexpected error:", err);
      handleCancel();
      setLoading(false);
    } finally{
      setLoading(false);
      handleCancel();
    }
  };
  const showSubmitConfirm = () => {
    confirm({
      title: selectedTask ? "Confirm Update" : "Confirm Submission",
      content: selectedTask
        ? "Are you sure you want to update this task?"
        : "Are you sure you want to submit this task?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        form.submit(); 
      },
    });
  };
  return (
    <Modal
      title={
        <div className="font-bold text-center  capitalize text-2xl m-5">
          {selectedTask ? "Update Task" : "Add Task"}
        </div>
      }
      open={isModalOpen}
      onOk={form.submit}
      onCancel={handleCancel}
      footer={null}
      width={1000}
    // style={{width : "400px !important" , backgroundColor : "red"}}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-0">
          <Form.Item
            label="Task Subject"
            name="taskSubject"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Task Subject" />
          </Form.Item>

          <Form.Item
            label="Project"
            name="project"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Project">
              {Array.isArray(projects) &&
                projects?.length > 0 &&
                projects?.map((item) => (
                  <Select.Option key={item.ID} value={item.ID}>
                    {item.TITLE}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Complain Date"
            name="complainDate"
          // rules={[{ required: true }]}
          >
            <DatePicker className="w-full" format="DD-MM-YYYY" />
          </Form.Item>

          <Form.Item
            label="Complain Source"
            name="complainsource"
          // rules={[{ required: true }]}
          >
            <Input placeholder="Enter Client Name" />
          </Form.Item>

          <Form.Item
            label="Assign By"
            name="assignBy"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Name" />
          </Form.Item>

          <Form.Item label="Status" name="status" rules={[{ required: true }]}>
            <Select placeholder="Select Status">
              <Select.Option value={0}>Assigned</Select.Option>
              <Select.Option value={1}>In Process</Select.Option>
              <Select.Option value={2}>On Hold</Select.Option>
              <Select.Option value={3}>Completed</Select.Option>
              <Select.Option value={4}>Rejected</Select.Option>
              <Select.Option value={5}>Canceled</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Assign Type"
            name="assignType"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Staff Type"
              onChange={(value) => setAssignTypeId(value)}
            >
              <Select.Option value={1}>Individual</Select.Option>
              <Select.Option value={2}>Team</Select.Option>
            </Select>
          </Form.Item>

          <div className="flex flex-col w-full">
            <label className="mb-1 font-semibold">
              <span className="text-red-500">*</span> Assign Staff
            </label>

            <Form.Item
              name="assignStaff"
              rules={[{ required: true, message: "Please select staff!" }]}
            >
              <SelectEmployee
                employeeList={filterData}
                onChange={(value) => setEmployeeId(value)}
                selectedEmployee={employeeId}
                customStyle="w-full"
                allLabel={{}}
                mode={assignTypeId == 2 ? "multiple" : null}
                allowClear
              />
            </Form.Item>
          </div>

          <Form.Item
            label="Assign Date"
            name="assigndate"
            rules={[{ required: true }]}
          >
            <DatePicker className="w-full" format="DD-MM-YYYY" />
          </Form.Item>

          <Form.Item
            label="Assign Time"
            name="assignTime"
            rules={[{ required: true }]}
          >
            <TimePicker
              // format="HH:mm:ss"
              use12Hours
              onChange={(time, timeString) => {
                // console.log(timeString, "assignTime timeString <<<<<<<<<<");
                setAssignTime(timeString);
              }}
            />
          </Form.Item>
          {/* </Space> */}

          <Form.Item
            label="Deadline Date"
            name="deadline"
          // rules={[{ required: true }]}
          >
            <DatePicker className="w-full" format="DD-MM-YYYY" />
          </Form.Item>

          {/* <Space wrap> */}
          <Form.Item
            label="Deadline Time"
            name="deadlineTime"
          // rules={[{ required: true }]}
          >
            <TimePicker
              // format="HH:mm:ss"
              use12Hours
              onChange={(time, timeString) => {
                // console.log(timeString, "deadlineTime timeString <<<<<<<<<<");
                setDeadLineTime(timeString);
              }}
            />
          </Form.Item>
          {/* </Space> */}

          <Form.Item
            label="Feature"
            name="feature"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your feature" />
          </Form.Item>

          <Form.Item
            label="Priority"
            name="priority"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Priority">
              <Select.Option value={1}>High</Select.Option>
              <Select.Option value={2}>Medium</Select.Option>
              <Select.Option value={3}>Low</Select.Option>
            </Select>
          </Form.Item>

          {selectedTask && (
            <>
              <Form.Item label="Approved By" name="approvedBy">
                <Input placeholder="Enter Name" />
              </Form.Item>

              <Form.Item label="Approved Date" name="approvedDate">
                <DatePicker className="w-full" format="DD-MM-YYYY" />
              </Form.Item>


              <Form.Item label="Complete Date" name="completeDate">
                <DatePicker className="w-full" format="DD-MM-YYYY" />
              </Form.Item>

              <Form.Item label="Complete Time" name="completeTime">
                <TimePicker
                  use12Hours
                  onChange={(time, timeString) => {
                    setCompleteTime(timeString);
                  }}
                />
              </Form.Item>

              <Form.Item label="Review / Remark" name="review">
                <TextArea rows={3} placeholder="Write review or remark..." />
              </Form.Item>
            </>
          )}
        </div>

        <Form.Item label="Description" name="description">
          <TextArea rows={3} placeholder="Enter task description..." />
        </Form.Item>

        <Form.Item className="text-center mt-4">
          <Button
            type="primary"
            size="large"
            disabled={loading}
            onClick={showSubmitConfirm}
            className=" w-full text-lg font-bold text-gray-100 p-4 px-12 bg-blue-500 hover:bg-blue-700"
          >
            {selectedTask ? "Update" : "Submit"}
          </Button>

        </Form.Item>
      </Form>
      <ToastContainer />
    </Modal>
  );
};

export default TaskModal;
